import moment from 'moment';
import { memo, useCallback } from 'react';
import { useEffectOnce } from 'react-use';
import Icon from '../../../components/icon/Icon';
import useRequest from '../../../hooks/useRequest';
import { useMst } from '../../../models';
import BoardService from '../../../services/BoardService';
import '../../Board/css/_custom.scss';
import { useTranslation } from 'react-i18next';
import { noticeListMenu } from '../../../menu';
import Badge from '../../../components/bootstrap/Badge';
import showNotification from '../../../components/extras/showNotification';
import CardBox from 'components/common/ui/CardBox';
import Txt from 'components/common/ui/Txt';
import Button from 'components/bootstrap/Button';
import NoData from 'components/common/ui/NoData';

const NoticeBoard = () => {
	const { t } = useTranslation();
	const tr = useCallback((name) => t(`userDashboard.${name}`), [t]);
	const { company } = useMst();
	const { responseData, loading, request } = useRequest([]);


	useEffectOnce(() => {
		request(
			BoardService.list,
			['notice', company.get.id],
			(res) => {
				if (res?.data) {
					const response = res.data;
					let sorted = [];
					response.sort((a, b) => {
						if (a.createdAt < b.createdAt) {
							return 1;
						}
						if (a.createdAt > b.createdAt) {
							return -1;
						}
						return 0;
					});
					sorted.push(...response.filter((data) => data?.category?.includes('ALL') === true));
					sorted.push(...response.filter((data) => data?.category?.includes('ALL') === false && data.notice === true));
					sorted.push(...response.filter((data) => data?.category?.includes('ALL') === false && data.notice === false));
					return { data: sorted };
				}
			},
			(error) => {
				showNotification(tr('notification'), tr('problemLoadingNotice'), 'danger');
			}
		);
	});

	function isWithinAWeek(dateString) {
		const inputDate = new Date(dateString);
		const currentDate = new Date();
		const oneWeek = 7 * 24 * 60 * 60 * 1000;
		return currentDate.getTime() - inputDate.getTime() <= oneWeek;
	}

	const timeForToday = (value) => {
		const today = new Date();
		const timeValue = new Date(value);

		const betweenTime = Math.floor((today.getTime() - timeValue.getTime()) / 1000 / 60);
		if (betweenTime < 1) return tr('justNow');
		if (betweenTime < 60) {
			return `${betweenTime}${tr('minAgo')}`;
		}

		const betweenTimeHour = Math.floor(betweenTime / 60);
		if (betweenTimeHour < 24) {
			return `${betweenTimeHour}${tr('hourAgo')}`;
		}

		return moment(timeValue).format('YYYY-MM-DD');
	};

	////////////////////////////////////////////////////////////////////////////////////
	//------------------------------------- 화면 -------------------------------------//
	return (
		<CardBox className='notice_card'>
			<CardBox.Header
				title={t('userDashboard.notification')}
				btnMoreTo={'/board/notice'}
			/>
			<CardBox.Body>
				{!loading && responseData.length <= 0 ? (
					// 데이터 없을 때
					<NoData />
				) : (
					responseData.map((v,i) => {
						return (
							<Button
								className='item'
								tag='a'
								to={(`${noticeListMenu.notice.path}/${responseData[i].idx}`)}
							>
								<span className={`title ${v.notice ? 'ico_important' : null }`}>
									<Txt as='span' weight='medium' color='black3'>{v.title}</Txt>
									<span className='ico_file'>{responseData[i]?.files?.length > 0 ? <Icon icon='AttachFile' /> : ''}</span>
									{isWithinAWeek(v.createdAt) && <Badge color='danger' className='ico_new'>N</Badge>}
								</span>
								<Txt variant='caption'>{timeForToday(v.createdAt)}</Txt>
							</Button>
						)
					})
				)}
			</CardBox.Body>
		</CardBox>
	);
};

export default memo(NoticeBoard);
